/**
 * @generated SignedSource<<61cdab2c01f0b75155485756620894a3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCreatorsPanel_item$data = {
  readonly storyTelling: {
    readonly tabs: ReadonlyArray<{
      readonly mainImage: string | null;
      readonly smallImage: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespCreatorsPanelCreator_storyTellingTab" | "getCreatorsAccordionTabs_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpRespCreatorsPanel_item";
};
export type PdpRespCreatorsPanel_item$key = {
  readonly " $data"?: PdpRespCreatorsPanel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCreatorsPanel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCreatorsPanel_item",
  "selections": [
    {
      "alias": "storyTelling",
      "args": [
        {
          "kind": "Literal",
          "name": "shortTitles",
          "value": true
        }
      ],
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getCreatorsAccordionTabs_storyTellingTab",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tabType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentHeader",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentBodyText",
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "smallImage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mainImage",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespCreatorsPanelCreator_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "storyTellingModule(shortTitles:true)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5d945a84fa27366d555f14d76e218948";

export default node;
